import { IContext } from '@ready/dashboardv2api.contracts';
import InfiniteScrollingListState from '../../../types/InfiniteScrollingListState.interface';
import InfiniteScrollingListStateHelper from '../../../utils/InfiniteScrollingList/InfiniteScrollingListStateHelper';

export interface IContextSwitcher extends InfiniteScrollingListState<IContext> {}

export const contextSwitcher = InfiniteScrollingListStateHelper.initialState() as IContextSwitcher;
